import React from 'react';
import { Fade } from '@oneaudi/aoa-shared-editorial-components';
import ResponsiveImage from '../ResponsiveImage/ResponsiveImage';
import { VideoPlayer } from '../VideoPlayer/VideoPlayer';
import { setAssetParams } from '../../utils/setAssetParams';

export const ResponsiveMedia = ({
  imageEnabled,
  fadeEnabled,
  fade,
  image,
  video,
  height,
  width,
  theme,
  isTest,
  layoutName,
  layoutSize,
  layoutSlot,
  useNewAspectRatioBehavior,
}) => {
  if (fadeEnabled) {
    const { color, direction, height: fadeHeight, opacity } = fade;
    return (
      <Fade
        color={color}
        direction={direction}
        height={fadeHeight}
        opacity={opacity}
        theme={theme}
        overlay
        cover
      >
        {imageEnabled ? (
          <ResponsiveImage
            {...setAssetParams({ image, video }, isTest, 'image').image}
            layoutSlot={layoutSlot}
            height={height}
            width={width}
            layoutName={layoutName}
            layoutSize={layoutSize}
            useNewAspectRatioBehavior={useNewAspectRatioBehavior}
          />
        ) : (
          <VideoPlayer
            {...setAssetParams({ video, image }, isTest, 'video').video}
            height={height}
            width={width}
            layoutName={layoutName}
            layoutSize={layoutSize}
            layoutSlot={layoutSlot}
            useNewAspectRatioBehavior={useNewAspectRatioBehavior}
            theme={theme}
            isTest={isTest}
          />
        )}
      </Fade>
    );
  }

  return imageEnabled ? (
    <ResponsiveImage
      {...setAssetParams({ image, video }, isTest, 'image').image}
      layoutSlot={layoutSlot}
      height={height}
      width={width}
      layoutName={layoutName}
      layoutSize={layoutSize}
      useNewAspectRatioBehavior={useNewAspectRatioBehavior}
    />
  ) : (
    <VideoPlayer
      {...setAssetParams({ video, image }, isTest, 'video').video}
      height={height}
      width={width}
      layoutName={layoutName}
      layoutSize={layoutSize}
      layoutSlot={layoutSlot}
      useNewAspectRatioBehavior={useNewAspectRatioBehavior}
      theme={theme}
      isTest={isTest}
    />
  );
};
